<!--
 * @Author: zl
 * @Date: 2022-09-15 15:06:50
 * @LastEditTime: 2022-09-16 17:46:21
 * @LastEditors: zl
 * @Description: 审计监督
-->
<template>
	<div class='AuditSupervision-layout'>
		<el-row>
			<el-col :span="22"
					:offset="1">
				<h2 class="text-center mb30">审 计 监 督</h2>
				<el-descriptions :column="2"
								 size="small"
								 border
								 class="custom-descriptions">
					<template slot="extra">
						编号：{{ form.serialNo }}
					</template>
					<el-descriptions-item label="审计任务名称"
										  :span="2">
						{{ form.taskIdName }}
					</el-descriptions-item>
					<el-descriptions-item label="工程项目名称"
										  :span="2">{{ currentObj.proName }}</el-descriptions-item>
					<el-descriptions-item label="标段名称">{{ form.packIdName }}</el-descriptions-item>
					<el-descriptions-item label="审计任务类型">{{ form.taskStatusName }}</el-descriptions-item>
					<el-descriptions-item label="建设单位">{{ form.ownerUnitName }}</el-descriptions-item>
					<el-descriptions-item label="监理单位">{{ form.supUnit }}</el-descriptions-item>
					<el-descriptions-item label="委托单位">{{ form.sponsorUnit }}</el-descriptions-item>
					<el-descriptions-item label="施工单位">{{ form.conUnit }}</el-descriptions-item>
					<el-descriptions-item label="监督人"
										  :span="2">{{ form.supUserName }}</el-descriptions-item>
					<el-descriptions-item label="监督类型"
										  :span="2">{{ form.typeName }}</el-descriptions-item>
					<el-descriptions-item label="监督记录"
										  :span="2"
										  contentClassName="h200">
						<div class="quill-editor editor w100">
							<div class="ql-container">
								<div class="ql-editor">
									<div v-html="form.remark"></div>
								</div>
							</div>
						</div>
					</el-descriptions-item>
					<el-descriptions-item label="附件上传"
										  :span="2">
						<myUpload listType="list"
								  ref="superviseUpload"
								  tableName="audit_supervise"
								  uploadType="2"
								  assortment="tessupervise"
								  width="auto"
								  height="auto"
								  :aid="form.id"
								  mode="view"
								  class="h100 w100"></myUpload>
					</el-descriptions-item>
					<el-descriptions-item label="协审单位"
										  :span="2">{{ form.tenantName }}</el-descriptions-item>
					<el-descriptions-item label="协审人员">{{ form.assistantUserName }}</el-descriptions-item>
					<el-descriptions-item label="日期">
						{{ form.compileDate ? form.compileDate.substr(0, 10) : '' }}
					</el-descriptions-item>
				</el-descriptions>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import * as API from '@/api/AuditReport/AuditReport'
export default {
	props: {
		currentObj: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: {},
	data() {
		return {
			form: {},
		}
	},
	created() {
		// 获取详情
		this.getDetails()
	},
	mounted() {},
	methods: {
		// 获取详情
		getDetails() {
			API.selectSuperviseDetail({
				id: this.currentObj.id,
			}).then((res) => {
				this.form = res.data
			})
		},
	},
	computed: {},
}
</script>

<style lang='less' scoped>
</style>